<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>help</v-icon>
          Invalidating Users
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-stepper v-model="step" vertical non-linear>
        <v-stepper-step editable step="1">
          <span class="blue--text" @click="openPage('help-signin')">Sign in</span> and click on "Invalidate" item under the "Users" menu.
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-card class="mb-5">
            <img src="~assets/images/help_userinvalidate_1.png">
          </v-card>
          <v-btn color="primary" @click="step = 2">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="2">
          Inform the User ID
          <small>Either fill in the user ID in the text box, or click on the QRCode button.</small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-card class="mb-5">
            <img src="~assets/images/help_userinvalidate_2.png">
          </v-card>
          <v-btn color="primary" @click="step = 3">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="3">
          Read the QRCode
          <small>If you have clicked on the QRCode button, point the User ID QRCode to your camera.</small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-card class="mb-5">
            <img src="~assets/images/help_userinvalidate_3.png">
          </v-card>
          <v-btn color="primary" @click="step = 4">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="4">
          See User's details
          <small>If that's a valid and active User ID, a confirmation message will show up. Click on the red button to invalidate the user.</small>
        </v-stepper-step>

        <v-stepper-content step="4">
          <v-card class="mb-5">
            <img src="~assets/images/help_userinvalidate_4.png">
          </v-card>
          <v-btn color="primary" @click="step = 1">Back to start</v-btn>
          <v-btn flat @click="openPage('help')">Back to help</v-btn>
        </v-stepper-content>

      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<style>
  .cursor:hover{
    cursor: pointer;
  }
</style>

<script>
export default {
  props: ['localUserType'],
  data () {
    return {
      localUserType: this.localUserType,
      step: 1
    }
  },
  methods: {
    openPage(name) {
      this.$emit("openPage", name);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/Help-Userinvalidate.vue